import { TOptionsBase } from "i18next";
import { $Dictionary } from "i18next/typescript/helpers";
import i18n from "./i18next";

export const snackTranslation = (text: string) => {
  return i18n.t(`snack.${text.replaceAll(/ & /g, "-&-").replaceAll(" ", "-").toLowerCase()}`);
};
export const cardTranslation = (text: string) => {
  return i18n.t(`cards.${text.replaceAll(/ & /g, "-&-").replaceAll(" ", "-").toLowerCase()}`);
};
export const sectionTranslation = (text: string, options?: TOptionsBase & $Dictionary) => {
  return i18n.t(`sections.${text.replaceAll(/ & /g, "-&-").replaceAll(" ", "-").toLowerCase()}`, options);
};
export const generalTranslation = (text: string, options?: TOptionsBase & $Dictionary) => {
  return i18n.t(`general.${text.replaceAll(/ & /g, "-&-").replaceAll(" ", "-").toLowerCase()}`, options);
};

export const editItineraryTranslation = (text: string, prefix?: string, options?: TOptionsBase & $Dictionary) => {
  const key =
    "edit-itinerary." +
    (prefix ? prefix + "." : "") +
    text.replaceAll(/ & /g, "-&-").replaceAll(" ", "-").toLowerCase();
  return i18n.t(key, options);
};
export const editItineraryFieldsTranslation = (text: string, options?: TOptionsBase & $Dictionary) => {
  return i18n.t(`edit-itinerary.fields.${text.replaceAll(/ & /g, "-&-").replaceAll(" ", "-").toLowerCase()}`, options);
};
export const editHeaderTranslation = (text: string) => {
  return i18n.t(`edit-itinerary.headers.${text.replaceAll(/ & /g, "-&-").replaceAll(" ", "-").toLowerCase()}`);
};

export const errorMessageTranslation = (text: string) => {
  return i18n.t(`edit-itinerary.errorMessage.${text.replaceAll(/ & /g, "-&-").replaceAll(" ", "-").toLowerCase()}`);
};
export const homeTranslation = (text: string) => {
  return i18n.t(`home.${text.replaceAll(/ & /g, "-&-").replaceAll(" ", "-").toLowerCase()}`);
};

export const accountTranslation = (text: string, options?: TOptionsBase & $Dictionary) => {
  return i18n.t(`account.${text.replaceAll(/ & /g, "-&-").replaceAll(" ", "-").toLowerCase()}`, options);
};

export const authenticationTranslation = (text: string, options?: TOptionsBase & $Dictionary) => {
  return baseTranslation("authentication", text, options);
};
export const guestTranslation = (text: string, options?: TOptionsBase & $Dictionary) => {
  return baseTranslation("guest", text, options);
};

/** A tab's label, shared by the web tab bar and the native one. */
export const navbarTranslation = (text: string, options?: TOptionsBase & $Dictionary) => {
  return baseTranslation("navbar", text, options);
};

/**
 * The native bar title a route declares in the registry. The English is the key, as with
 * every helper above. Untranslated titles resolve through the en-GB fallback.
 */
export const routeTitleTranslation = (text: string, options?: TOptionsBase & $Dictionary) => {
  return baseTranslation("routes", text, options);
};

const baseTranslation = (prefix: string, text: string, options?: TOptionsBase & $Dictionary) => {
  return i18n.t(`${prefix}.${text.replaceAll(/ & /g, "-&-").replaceAll(" ", "-").toLowerCase()}`, options);
};
